import { ReactNode, HTMLAttributes } from "react";
import clsx from "clsx";

type ContainerProps = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode;
  className?: string;
};

const Container = ({ children, className = "", ...props }: ContainerProps) => (
  <div
    className={clsx("default_container", className)}
    {...props}
  >
    {children}
  </div>
);

type CardProps = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode;
  className?: string;
};

const Card = ({ children, className = "", ...props }: CardProps) => (
  <div
    className={clsx("default_card", className)}
    {...props}
  >
    {children}
  </div>
);

export {
  Container,
  Card,
};
